<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/a9PdBg/tc-custom/9781488033100.jpg?1705950839795" alt="This image is the cover for the book Ranger Defender, Texas Brothers of Company B"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ranger Defender, Texas Brothers of Company B
      </h1>
      <p class="bookDescription body article font2">
        <b>“Angi Morgan proves that she is one of the giants of romantic suspense . . . The villain is as masterful a creation as they come . . . fantastic.” —<i>Fresh Fiction</i></b><br/><br/>She needed a miracle.<br/><br/>She got a Texas Ranger.<br/><br/>Vivian Watts’s mission to prove her brother’s innocence has left her destitute and desperate. So when Texas Ranger Slate Thompson arrives with his knock-me-out blue eyes and belief in her case, she dares to hope again . . . until her apartment is burned to the ground. Slate offers refuge at his ranch, but when evidence suggests Vivian is being hunted . . . can he face down the real killer to protect her?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Angi Morgan
      </h2>
      
      <p class="authorDescription body article">&#160;<Br><Br>Using&#160;actual Texas settings and realistic characters, this <I>USA Today</I> and <I>Publisher&#39;s Weekly</I> bestseller, creates stories with characters who put everything on the line. Angi is an 11th generation Texan who lives there with her husband and &#39;four-legged&#39; kids. Find her at AngiMorganAuthor.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f7ebc1e